/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TransactionIn } from './TransactionIn';
import {
    TransactionInFromJSON,
    TransactionInFromJSONTyped,
    TransactionInToJSON,
} from './TransactionIn';

/**
 * 
 * @export
 * @interface MoneyIn3DConfirmOutput
 */
export interface MoneyIn3DConfirmOutput {
    /**
     * 
     * @type {TransactionIn}
     * @memberof MoneyIn3DConfirmOutput
     */
    transaction?: TransactionIn;
    /**
     * 
     * @type {Error}
     * @memberof MoneyIn3DConfirmOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the MoneyIn3DConfirmOutput interface.
 */
export function instanceOfMoneyIn3DConfirmOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MoneyIn3DConfirmOutputFromJSON(json: any): MoneyIn3DConfirmOutput {
    return MoneyIn3DConfirmOutputFromJSONTyped(json, false);
}

export function MoneyIn3DConfirmOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoneyIn3DConfirmOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transaction': !exists(json, 'transaction') ? undefined : TransactionInFromJSON(json['transaction']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function MoneyIn3DConfirmOutputToJSON(value?: MoneyIn3DConfirmOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transaction': TransactionInToJSON(value.transaction),
        'error': value.error,
    };
}

